import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    container: {
      border: '1px solid #F0F0F0',
      borderRadius: 5,
    },
    layerName: {
      display: 'inline-flex',
      flex: 1,
      marginBottom: '1.3rem',
      marginLeft: '0.4rem',

      fontWeight: 600,
      fontSize: '1.2rem',

      '& span:first-child': {
        flex: 1,
      },
    },
  }),
)
